import type { InstrumentFormData } from './InstrumentFormFields'

export interface InstrumentFormPayload {
  instrument: Omit<
    InstrumentFormData,
    'instrumentTypeId' | 'siteId' | 'departmentId' | 'unitId'
  > & {
    siteId: string | null
    departmentId: string | null
    unitId: string | null
    instrumentTypeId?: string | null
  }
}

export const buildInstrumentFormPayload = (
  data: InstrumentFormData,
  isEdit: boolean,
): InstrumentFormPayload => {
  const { instrumentTypeId, ...fieldsWithoutType } = data

  return {
    instrument: {
      ...(isEdit ? fieldsWithoutType : { ...data, instrumentTypeId: instrumentTypeId || null }),
      instrumentLabel: data.instrumentLabel.trim(),
      siteId: data.siteId || null,
      departmentId: data.departmentId || null,
      unitId: data.unitId || null,
    },
  }
}
